export const PortfolioAllNames = [
	"Solar_All",
	"Wind_Offshore_All",
	"Wind_Onshore_All",
];
